<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="原告名称" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.accuser_name }}
            </template>
        </el-table-column>
        <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案由名称">
            <template slot-scope="scope">
              {{ scope.row.cause_of_action_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="法院名称（执行者）">
            <template slot-scope="scope">
              {{ scope.row.court_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="被告名称">
            <template slot-scope="scope">
              {{ scope.row.defendant_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="公告日期">
            <template slot-scope="scope">
              {{ scope.row.filing_date || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'filingList',
    data() {
        return {
            title: '立案信息',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>